import React, { useEffect, useMemo } from 'react'
import { useDataValue, useDataChange, useDataSubmit } from 'Simple/Data.js'

import Connection from './Connection/index.js'
import ConnectionTitle from './ConnectionTitle/index.js'
import AddedByTitle from './AddedByTitle/index.js'
import ExpiresTitle from './ExpiresTitle/index.js'
import Expires from './Expires/index.js'
import ActionsColumn from './ActionsColumn/index.js'
import AddedBy from './AddedBy/index.js'

import View from './view.js'

export default function Logic(props) {
  let connections = useDataValue({
    context: 'app',
    path: 'connections',
    viewPath: props.viewPath,
  })

  let refetch = useDataValue({
    context: 'tab',
    path: 'selected.refetch_connections',
    viewPath: props.viewPath,
  })

  let setRefetchConnections = useDataChange({
    context: 'tab',
    path: 'selected.refetch_connections',
    viewPath: props.viewPath,
  })

  let submit = useDataSubmit({
    context: 'app',
    viewPath: props.viewPath,
  })

  useEffect(() => {
    if (!refetch) return

    submit({ type: 'refetch' })
    setRefetchConnections(null)
  }, [refetch]) // eslint-disable-line react-hooks/exhaustive-deps
  // ignore submit

  let tableData = useMemo(
    () => ({
      columns: [
        {
          id: 'connection',
          header: <ConnectionTitle />,
          cell: cell => (
            <Connection
              value={cell.row.original}
              viewPath={`${props.viewPath}/Connection(${cell.row.original.id})`}
            />
          ),
        },
        {
          header: <ExpiresTitle />,
          id: 'expires',
          cell: cell => (
            <Expires
              value={cell.row.original}
              viewPath={`${props.viewPath}/Expires(${cell.row.original.id})`}
            />
          ),
        },
        {
          header: <AddedByTitle />,
          id: 'addedBy',
          accessorKey: 'user',
          cell: cell => (
            <AddedBy
              value={cell.row.original}
              viewPath={`${props.viewPath}/AddedBy(${cell.row.original.id})`}
            />
          ),
        },

        {
          // ActionsColumn
          header: () => (
            <div style={{ textAlign: 'right', paddingRight: '30px' }}>
              Actions
            </div>
          ),
          id: 'actions',
          accessorKey: 'name',
          cell: cell => (
            <ActionsColumn
              value={cell.row.original}
              viewPath={`${props.viewPath}/ActionsColumn(${cell.row.original.id})`}
            />
          ),
        },
      ],
      data: connections ?? [],
    }),
    [connections]
  )

  return <View viewPath={props.viewPath} tableData={tableData} />
}
